(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["contact-us"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.wiInquiryInstalled) return;
  window.wiInquiryInstalled = true;

  function sync(form) {
    const phone = form.querySelector('[name="contact[phone]"]');
    const phoneLabel = form.querySelector('[data-phone-label]');
    const reply = form.querySelector('[name="contact[Preferred reply]"]:checked');

    if (phone && phoneLabel) {
      phone.required = reply?.value === 'Phone';
      phoneLabel.textContent = phone.required
        ? 'Phone number *'
        : 'Phone number (optional)';
      phone.setCustomValidity(
        phone.required && !phone.value.trim()
          ? 'Please enter your phone number.'
          : ''
      );
    }

    const reasons = Array.from(
      form.querySelectorAll('[data-inquiry-reason]:checked')
    );
    const other = reasons.some(
      input => input.dataset.inquiryReason === 'Other'
    );
    const delivery = reasons.some(
      input => input.dataset.inquiryReason === 'Delivery timing'
    );

    const details = form.querySelector('#wi-details');
    const otherText = form.querySelector('#wi-other');
    if (!details || !otherText) return;

    form.querySelector('[data-details-panel]').hidden = other;
    form.querySelector('[data-other-panel]').hidden = !other;

    details.disabled = other;
    details.required = !other && reasons.length === 0;
    otherText.disabled = !other;
    otherText.required = other;

    form.querySelector('[data-details-label]').textContent =
      details.required
        ? 'How can we help? *'
        : 'Additional details (optional)';

    form.querySelector('[data-delivery-help]').hidden = !delivery;

    for (const text of [details, otherText]) {
      const empty = text.required && !text.disabled && !text.value.trim();
      text.setCustomValidity(
        empty ? 'Please tell us how we can help.' : ''
      );
      text.parentElement.querySelector('[data-text-counter]').textContent =
        text.value.length.toLocaleString() + ' / 1,000 characters';
    }
  }

  for (const eventName of ['change', 'input', 'focusin']) {
    document.addEventListener(eventName, event => {
      const form = event.target.closest('.wi-inquiry-form');
      if (form) sync(form);
    });
  }

  document.addEventListener('submit', event => {
    const form = event.target.closest('.wi-inquiry-form');
    if (!form) return;

    sync(form);

    if (!form.checkValidity()) {
      event.preventDefault();
      form.reportValidity();
    }
  }, true);

  function reopenErrors() {
    const source = document.getElementById('askquestion-popup');
    if (source?.content?.querySelector('.wi-inquiry-errors')) {
      document.querySelector('.open-askquestion-popup')?.click();
    }
  }

  if (document.readyState === 'complete') reopenErrors();
  else window.addEventListener('load', reopenErrors, { once: true });
})();
  } catch(e) { console.error(e); }
})();

})();
